export default __webpack_public_path__ + "static/media/102-desktop.d9d94146.jpg";